// @flow
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import style from './Arrow.scss';

type Props = {
  +onClick?: () => void;
  +icon: string;
  +positionClass: string;
  +visible: boolean;
};

export default class Arrow extends Component<Props, void> {

  render() {
    const { onClick, icon, positionClass, visible } = this.props;
    return (
      <div
        className={classNames(style.arrow, positionClass, {[style.visible]: visible})}
        onClick={onClick}><i className={icon}/>
      </div>
    );
  }
}

Arrow.propTypes = {
  onClick: PropTypes.func,
  icon: PropTypes.string.isRequired,
  positionClass: PropTypes.string.isRequired,
  visible: PropTypes.bool,
};



// WEBPACK FOOTER //
// ./src/elements/Arrow/Arrow.jsx